import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const auditFlowGuard: CanActivateFn = route => {
  const router = inject(Router);

  if (environment.isAuditFlowEnabled) {
    return true;
  }

  const agent = route.params['agent'];
  return router.createUrlTree([`/${agent}/handles`]);
};
